import { GridFilterReducer } from '../../../common/grid/filter/grid-filter.reducer';
import { GridReducer } from '../../../common/grid/grid.reducer';

export default {
    pnpSettingsDocumentType: {
        name: null,
        code: null,
        contractTypeName: null,
        shortName: null,
        description: null,
    },
    pnpSettingsDocumentTypeGrid: {
        ...GridReducer(),
        items: [],
        itemsCount: 0,
        filter: {
            ...GridFilterReducer()
        }
    },
    pnpSettingsDocumentCategory: {
        id: null,
        name: null,
        cat_num: null,
        location: null,
        locationName: null,
        locations: [],
        defaultCategories: [],
        prefix: null
    },
    pnpSettingsDocumentCategoryGrid: {
        ...GridReducer(),
        items: [],
        itemsCount: 0,
        filter: {
            ...GridFilterReducer(),
            identifier: 'pnpSettingsDocumentCategory'
        }
    },
    pnpSettingsApprovalWorkflow: {
        id: null,
        riskDuration: null,
        documentRiskLevel: null,
        documentCategory: null,
        documentContainer: null,
        documentAuditType: null,
        documentAuditTypes: [],
        documentTaskTypes: [],
        documentContainerTypes: [],
        documentCategories: [],
        documentRiskLevels: [],
        selectedReviewer: null,
        selectedReviewers: [],
        selectedApprover: null,
        selectedApprovers: [],
    },
    pnpSettingsApprovalWorkflowGrid: {
        ...GridReducer(),
        items: [],
        itemsCount: 0,
        filter: {
            ...GridFilterReducer(),
            identifier: 'pnpSettingsApprovalWorkflow'
        }
    },
    pnpComplianceReportGrid: {
        ...GridReducer(),
        items: [],
        itemsCount: 0,
        filter: {
            ...GridFilterReducer(),
            identifier: 'pnpDocument',
            report: true
        }
    },
};
